<template>
  <a-tooltip
    v-if="tooltipText"
    :destroy-tooltip-on-hide="true"
    :get-popup-container="getPopupContainer"
  >
    <template v-if="tooltipText.length" #title>{{ tooltipText }}</template>
    <div
      :class="`${color ? 'text-white bg-' + getColorSuffix(color, border) : 'border border-2'} ${
        $style['status-badge']
      } ${$style['status-badge-' + size]} ${square ? 'rounded' : 'rounded-circle'} ${
        border
          ? `border ${size === 'xs' ? 'border-1' : 'border-2'} border-${getColorSuffix(
              color,
              false
            )} text-${getColorSuffix(color, false)}`
          : ''
      }`"
      class="user-select-none overflow-hidden"
    >
      <span>{{ label || '?' }}</span>
    </div>
  </a-tooltip>
  <div
    v-else
    :class="`${color ? 'bg-' + getColorSuffix(color, border) : 'border border-2'} ${
      $style['status-badge']
    }
    ${$style['status-badge-' + size]} ${square ? 'rounded' : 'rounded-circle'} ${
      border
        ? `border ${size === 'xs' ? 'border-1' : 'border-2'} border-${getColorSuffix(
            color,
            false
          )} text-${getColorSuffix(color, false)}`
        : ''
    }`"
    class="user-select-none overflow-hidden"
  >
    <span>{{ label || '?' }}</span>
  </div>
</template>
<script lang="ts" setup>
import { getColorSuffix } from '@/helpers/status.helper'
import { BadgeSize, LeadStatusColor } from '@/shared'
import { PropType } from 'vue'
import { asyncComponentWrapper } from '@/composables/useReloadModal'

const ATooltip = asyncComponentWrapper(() => import('ant-design-vue/es/tooltip'))

const props = defineProps({
  label: {
    type: String,
    required: false,
    default: ''
  },
  tooltipText: {
    type: String,
    required: false,
    default: ''
  },
  color: {
    type: String as PropType<LeadStatusColor>,
    required: false,
    default: ''
  },
  parentContainer: {
    type: Boolean,
    default: false
  },
  square: {
    type: Boolean,
    default: true
  },
  border: {
    type: Boolean,
    default: false
  },
  size: {
    type: String as PropType<BadgeSize>,
    default: 'md'
  }
})

const getPopupContainer = (triggerNode: HTMLElement) =>
  props.parentContainer ? <HTMLElement>triggerNode.parentNode : document.body
</script>

<style lang="scss" module>
.status-badge {
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
  }
}

.status-badge-lg {
  width: 2.5rem;
  height: 2.5rem;
}

.status-badge-sm {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
  padding: 0.75rem;

  > span {
    font-size: 0.625rem;
  }
}

.status-badge-xs {
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  min-height: 1rem;
  padding: 0.55rem;

  > span {
    font-size: 0.5rem;
  }
}
</style>
